import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';

import { SnIntegration } from '@lib/api/entities';
import { FsMapAerisWeatherRadarServiceProvider, IFsMap } from '@lib/geo/core';

@Injectable()
export class MapAerisWeatherRadarFacadeService<
  TMap extends IFsMap,
> extends FsMapAerisWeatherRadarServiceProvider<TMap> {
  constructor(private readonly provider: FsMapAerisWeatherRadarServiceProvider<TMap>) {
    super();
  }

  public get geospatialProvider(): string {
    return this.provider.geospatialProvider;
  }

  public get id(): string {
    return this.provider.id;
  }

  public get isPremium(): boolean {
    return this.provider.isPremium;
  }

  public get currentFrame$(): Observable<number> {
    return this.provider.currentFrame$;
  }

  public onMapLoaded(map: TMap): void {
    return this.provider.onMapLoaded(map);
  }

  public addToMap(): void {
    return this.provider.addToMap();
  }

  public get isAvailable(): boolean {
    return this.provider.isAvailable;
  }

  public set isAnimationPlaying(value: boolean) {
    this.provider.isAnimationPlaying = value;
  }

  public get isAnimationPlaying(): boolean {
    return this.provider.isAnimationPlaying;
  }

  public set selectedFrame(value: number) {
    this.provider.selectedFrame = value;
  }

  public get selectedFrame(): number {
    return this.provider.selectedFrame;
  }

  public get startHours(): number {
    return this.provider.startHours;
  }

  public get endHours(): number {
    return this.provider.endHours;
  }

  public get frameCount(): number {
    return this.provider.frameCount;
  }

  public get timer(): ReturnType<typeof setTimeout> {
    return this.provider.timer;
  }

  public get interval(): ReturnType<typeof setInterval> {
    return this.provider.interval;
  }

  public removeFromMap(): void {
    return this.provider.removeFromMap();
  }

  public getIntegration(): Observable<SnIntegration> {
    return this.provider.getIntegration();
  }

  public reload(): void {
    return this.provider.reload();
  }

  public clearTimers(): void {
    return this.provider.clearTimers();
  }
}
